<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Candidates source') }}</h4>
        </div>
        <div>
          <div class="form-inline">
            <div class="form-group mr-2">
              <range-date-filter
                :value="rangeDate"
                @input="(v) => { setFilters({created_at: v}) }"
                style="min-width: 210px"> 
                </range-date-filter>
            </div>
            <button
              class="btn btn-light"
              @click="exportReport">
              {{ $t('Export xlsx') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="grid.total"
          :pages="grid.pages"
          :page="grid.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content" v-if="!creating">
            <div style="overflow: hidden;">
              <div class="row">
                <div
                  class="col-sm">
                  <div class="p-4">
                    <highcharts
                      :options="chartOptions1">
                      </highcharts>
                  </div>
                </div>
                <div
                  class="col-sm">
                  <div class="p-4">
                    <highcharts
                      :options="chartOptions2">
                      </highcharts>
                  </div>
                </div>
              </div>
            </div>

            <table
              v-if="grid.docs.length"
              class="table table-bordered">
              <thead  class="thead-fixed">
                <tr>
                  <th-sort field="origin" :value="sort" @input="setSort">Origem</th-sort>
                  <th-sort field="source" :value="sort" @input="setSort">{{ $t('Source') }}</th-sort>
                  <th-sort field="total_candidates" :value="sort" @input="setSort">{{ $t('Candidates') }}</th-sort>
                  <th-sort field="total_hireds" :value="sort" @input="setSort">{{ $t('Hireds') }}</th-sort>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in grid.docs">
                  <td class="text-truncate">{{ getOriginName(item.origin) }}</td>
                  <td class="text-truncate">{{ getSourceName(item.source) }}</td>
                  <td class="text-truncate">{{ item.total_candidates }}</td>
                  <td class="text-truncate">{{ item.total_hireds }}</td>
                </tr>
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>

    </div>

  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'
import Filterfy from '@/components/Filterfy/Filterfy'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import RangeDateFilter from './RangeDateFilter'
import BlobDownload from '@/utils/BlobDownload'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import moment from 'moment'

export default {
  name: 'ReportJobDetails',
  components: {
    highcharts: Chart,
    Filterfy,
    ThSort,
    Paginaty,
    RangeDateFilter
  },
  data () {
    return {
      creating: true,
      loading: true,
      filtersMap: [
      ],
      grid: []
    }
  },
  computed: {
    chartOptions1 () {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        lang: {
          noData: this.$t('No data to display')
        },
        title: {
          text: this.$t('Candidates')
        },
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          }
        },
        series: [{
          data: this.grid.docs.map((item) => {
            return {
              name: `${this.getOriginName(item.origin)} (${this.getSourceName(item.source)})`,
              y: item.total_candidates
            }
          })
          .filter((val) => {
            return val.y > 0
          })
        }]
      }
    },
    chartOptions2 () {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        lang: {
          noData: this.$t('No data to display')
        },
        title: {
          text: this.$t('Hireds')
        },
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          }
        },
        series: [{
          data: this.grid.docs.map((item) => {
            return {
              name: `${this.getOriginName(item.origin)} (${this.getSourceName(item.source)})`,
              y: item.total_hireds
            }
          })
          .filter((val) => {
            return val.y > 0
          })
        }]
      }
    },
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || 'origin'
    },
    rangeDate () {
      const defaultDate = `d|${moment().subtract(30, 'days').toISOString()}|${moment().toISOString()}`
      return this.$route.query.created_at === undefined ? defaultDate : this.$route.query.created_at
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        created_at: this.rangeDate,
        page: this.$route.query.page || 1,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/candidate-source', {params: params})
      .then((response) => {
        this.grid = response.data
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    getOriginName (origin) {
      return {
        'sourced': 'Prospect',
        'referred': this.$t('Recommendation'),
        'applied': this.$t('Application'),
        'internal_applied': this.$t('Internal application')
      }[origin] || 'N/D'
    },
    getSourceName (source) {
      return source || 'N/D'
    },
    exportReport () {
      const params = {
        ...this.filters,
        sort: this.sort
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/candidate-source/export', {params: params, responseType: 'blob', timeout: 30000})
      .then((response) => {
        BlobDownload(response)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportCandidateSource.vue